import { Component, Input, OnInit } from '@angular/core';
import { Processo, ProcessoInstancia } from '../processo.model';
import { ConsultaPaginada, MensagemService, ProgressoService, Restricao, RestricaoOperador, RestricaoPadrao } from 'maestro-ng';
import { ProcessoClasseService } from '../../processo-classe/processo-classe.service';
import { ProcessoDistribuicaoService } from '../../processo-distribuicao/processo-distribuicao.service';
import { ProcessoDocumentoService } from '../../processo-documento/processo-documento.service';
import { ProcessoMovimentoService } from '../../processo-movimento/processo-movimento.service';
import { ProcessoDocumento } from '../../processo-documento/processo-documento.model';
import { ArquivoVisualizavel } from '../../components/arquivo-visualizador/arquivo-visualizavel.model';
import { ProcessoMovimento } from '../../processo-movimento/processo-movimento.model';
import { ProcessoClasse } from '../../processo-classe/processo-classe.model';
import { ProcessoDistribuicao } from '../../processo-distribuicao/processo-distribuicao.model';
import {
  LinhaDoTempo,
  LinhaTempoData,
  ProcessoClasseLinhaTempo,
  ProcessoDistribuicaoLinhaTempo,
  ProcessoDocumentoLinhaTempo,
  ProcessoMovimentoLinhaTempo,
} from './processo-linha-tempo';
import { ProcessoVisualizadorComponent } from '../processo-visualizador/processo-visualizador.component';

@Component({
  selector: 'app-processo-linha-tempo',
  templateUrl: './processo-linha-tempo.component.html',
  styleUrls: ['./processo-linha-tempo.component.css'],
})
export class ProcessoLinhaTempoComponent implements OnInit {
  @Input() processo!: Processo;

  public tabViewDocumentosIndex = 0;
  public limite = 100;

  public fimPaginacaoDocumentos: boolean;
  public fimPaginacaoMovimentos: boolean;

  public processoDocumentoTexto: string;
  public processoDocumentoArquivo: ArquivoVisualizavel;

  public classeLinhaDoTempo: ProcessoClasse[] = [];
  public distribuicaoLinhaDoTempo: ProcessoDistribuicao[] = [];
  public dsDocumentoLinhaDoTempo: ProcessoDocumento[] = [];
  public dsMovimentoLinhaDoTempo: ProcessoMovimento[] = [];
  public listaLinhaTempos: LinhaTempoData[] = [];
  public apresentarClasse: Boolean = false;
  public apresentarDistribuicao: Boolean = false;
  public apresentarDocumento: Boolean = false;
  public apresentarMovimento: Boolean = false;
  public processoClasseSelecionada: ProcessoClasse;
  public processoDistribuicaoSelecionada: ProcessoDistribuicao;
  public processoDocumentoSelecionada: ProcessoDocumento;
  public processoMovimentoSelecionada: ProcessoMovimento;

  constructor(
    private processoClasseService: ProcessoClasseService,
    private processoDistribuicaoService: ProcessoDistribuicaoService,
    private processoDocumentoService: ProcessoDocumentoService,
    private processoMovimentoService: ProcessoMovimentoService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService
  ) {}

  ngOnInit(): void {
    Promise.all([this.carregarClasses(), this.carregarDistribuicoes(), this.carregarDocumentos(), this.carregarMovimentos()])
      .then(() => {
        this.processarLinhaDoTempo();
        this.abrirDetalhes(this.listaLinhaTempos[0][0]);
      })
      .catch((error) => {
        console.error('Erro ao carregar os dados', error);
      });
  }

  public carregarClasses(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.progressoService.modeless();
      this.processoClasseService
        .recuperarPorProcessoId(this.processo.id)
        .then((classes) => {
          this.classeLinhaDoTempo = classes;
          this.progressoService.fechar();
          resolve();
        })
        .catch((response) => {
          this.catch('Erro ao carregar o histórico de classes do processo', response.error);
          reject(response.error);
        });
    });
  }

  public carregarDistribuicoes(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.progressoService.modeless();
      this.processoDistribuicaoService
        .recuperarPorProcessoId(this.processo.id)
        .then((distribuicoes) => {
          this.distribuicaoLinhaDoTempo = distribuicoes;
          this.progressoService.fechar();
          resolve();
        })
        .catch((response) => {
          this.catch('Erro ao carregar o histórico de distribuições do processo', response.error);
          reject(response.error);
        });
    });
  }

  public carregarDocumentos(): Promise<void> {
    return new Promise((resolve, reject) => {
      const consulta = new ConsultaPaginada();
      consulta.inicio = 0;
      consulta.limite = this.limite;

      if (this.dsDocumentoLinhaDoTempo.length === 0) {
        consulta.restricoes = [];
      } else {
        const processoDocumento = this.dsDocumentoLinhaDoTempo[this.dsDocumentoLinhaDoTempo.length - 1];

        const processoDocumentosMesmaData: ProcessoDocumento[] = this.dsDocumentoLinhaDoTempo.filter((value) => {
          const processoDate = new Date(processoDocumento.dataJuntada);
          const valueDate = new Date(value.dataJuntada);
          return (
            processoDate.getFullYear() === valueDate.getFullYear() &&
            processoDate.getMonth() === valueDate.getMonth() &&
            processoDate.getDate() === valueDate.getDate() &&
            processoDate.getHours() === valueDate.getHours() &&
            processoDate.getMinutes() === valueDate.getMinutes()
          );
        });
        consulta.restricoes = [
          new Restricao<Date>({
            atributo: 'dataJuntada',
            operador: RestricaoOperador.LE,
            padrao: RestricaoPadrao.DATE,
            valor: processoDocumento.dataJuntada,
          }),
          new Restricao<Date>({
            atributo: 'origemId',
            operador: RestricaoOperador.NOT_IN,
            valores: processoDocumentosMesmaData.map((value) => value.origemId),
          }),
        ];
      }
      consulta.ordenacoes = [
        { atributo: 'dataJuntada', ordem: 'DESC' },
        { atributo: 'origemId', ordem: 'DESC' },
      ];
      consulta.contabilizar = true;

      this.processoDocumentoService
        .recuperarPaginadoPorProcesso(this.processo.id, consulta)
        .then((resultado) => {
          this.dsDocumentoLinhaDoTempo.push(...resultado.entidades);
          this.fimPaginacaoDocumentos = resultado.total > this.limite;
          resolve();
        })
        .catch((response) => {
          this.mensagemService.addErro('Erro ao carregar os dados da pesquisa!', response.error);
          reject(response.error);
        });
    });
  }

  private processarHierarquia(documentos: ProcessoDocumento[]): void {
    if (documentos !== undefined) {
      const pais = documentos.filter((d) => d !== undefined && d.pai === undefined);
      const filhos = documentos.filter((d) => d !== undefined && d.pai !== undefined);
      filhos.forEach((f) => (f.pai = pais.filter((p) => p.id === f.pai.id)[0]));
      pais.forEach((p) => (p.filhos = filhos.filter((f) => f.pai === p)));
    }
  }

  public carregarMovimentos(): Promise<void> {
    return new Promise((resolve, reject) => {
      const consulta = new ConsultaPaginada();
      consulta.inicio = 0;
      consulta.limite = this.limite;
      if (this.dsMovimentoLinhaDoTempo.length === 0) {
        consulta.restricoes = [];
      } else {
        const processoMovimento = this.dsMovimentoLinhaDoTempo[this.dsMovimentoLinhaDoTempo.length - 1];

        const processoMovimentoMesmaData: ProcessoMovimento[] = this.dsMovimentoLinhaDoTempo.filter((value) => {
          const processoDate = new Date(processoMovimento.data);
          const valueDate = new Date(value.data);
          return (
            processoDate.getFullYear() === valueDate.getFullYear() &&
            processoDate.getMonth() === valueDate.getMonth() &&
            processoDate.getDate() === valueDate.getDate() &&
            processoDate.getHours() === valueDate.getHours() &&
            processoDate.getMinutes() === valueDate.getMinutes()
          );
        });

        consulta.restricoes = [
          new Restricao<Date>({
            atributo: 'data',
            operador: RestricaoOperador.LE,
            padrao: RestricaoPadrao.DATE,
            valor: processoMovimento.data,
          }),
          new Restricao<Date>({
            atributo: 'origemId',
            operador: RestricaoOperador.NOT_IN,
            valores: processoMovimentoMesmaData.map((value) => value.origemId),
          }),
        ];
      }
      consulta.ordenacoes = [
        { atributo: 'data', ordem: 'DESC' },
        { atributo: 'origemId', ordem: 'DESC' },
      ];
      consulta.contabilizar = true;

      this.processoMovimentoService
        .recuperarPaginadoPorProcesso(this.processo.id, consulta)
        .then((resultado) => {
          this.dsMovimentoLinhaDoTempo.push(...resultado.entidades);
          this.fimPaginacaoMovimentos = resultado.total > this.limite;
          resolve();
        })
        .catch((response) => {
          this.mensagemService.addErro('Erro ao carregar os dados da pesquisa!', response.error);
          reject(response.error);
        });
    });
  }

  public processarLinhaDoTempo(): void {
    const classes: ProcessoClasseLinhaTempo[] = [];
    const distribuicao: ProcessoDistribuicaoLinhaTempo[] = [];
    const documentos: ProcessoDocumentoLinhaTempo[] = [];
    const movimentos: ProcessoMovimentoLinhaTempo[] = [];

    for (const classe of this.classeLinhaDoTempo) {
      const value = new ProcessoClasseLinhaTempo(classe);
      classes.push(value);
    }

    for (const distribuicaoDados of this.distribuicaoLinhaDoTempo) {
      const value = new ProcessoDistribuicaoLinhaTempo(distribuicaoDados);
      distribuicao.push(value);
    }

    for (const documentoDados of this.dsDocumentoLinhaDoTempo) {
      const value = new ProcessoDocumentoLinhaTempo(documentoDados);
      documentos.push(value);
    }

    for (const movimentoDados of this.dsMovimentoLinhaDoTempo) {
      const value = new ProcessoMovimentoLinhaTempo(movimentoDados);
      movimentos.push(value);
    }

    const linhaDoTempo: LinhaDoTempo<any>[] = [...classes, ...distribuicao, ...movimentos, ...documentos];

    const linhaDoTempoAgrupado = this.agruparPorHoraMinuto(linhaDoTempo);

    linhaDoTempoAgrupado.forEach((linhas) => {
      const linhaTempoMomento = <any>[];
      linhas.forEach((l) => {
        linhaTempoMomento.push(l);
      });
      this.listaLinhaTempos.push(linhaTempoMomento);
    });
  }

  public catch(titulo: string, mensagem: string): void {
    this.progressoService.fechar();
    this.mensagemService.addErro(titulo, mensagem);
  }

  public agruparPorHoraMinuto(linhas: LinhaDoTempo<any>[]): Map<string, LinhaDoTempo<any>[]> {
    linhas.sort((a, b) => new Date(a.getData()).getTime() - new Date(b.getData()).getTime());

    const grupos = new Map<string, LinhaDoTempo<any>[]>();

    linhas.forEach((linha) => {
      let data = linha.getData();

      if (linha.getTipo() === 'Distribuição') {
        data = linha.getItem().dataInicio;
      }
      const chave = this.criarChaveAgrupamento(new Date(data));
      if (!grupos.has(chave)) {
        grupos.set(chave, []);
      }
      grupos.get(chave)?.push(linha);
    });

    const gruposOrdenados = new Map(
      Array.from(grupos.entries()).sort(([chaveA], [chaveB]) => {
        const dataA = new Date(chaveA.split('/').reverse().join('-'));
        const dataB = new Date(chaveB.split('/').reverse().join('-'));
        return dataB.getTime() - dataA.getTime();
      })
    );

    return gruposOrdenados;
  }

  public criarChaveAgrupamento(data: Date): string {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  isSegundoGrau(): boolean {
    return this.processo !== undefined && this.processo.instancia === ProcessoInstancia.SEGUNDO_GRAU;
  }

  public abrirDetalhes(item: LinhaDoTempo<any>) {
    this.apresentarClasse = false;
    this.apresentarDistribuicao = false;
    this.apresentarDocumento = false;
    this.apresentarMovimento = false;

    switch (item.getTipo()) {
      case 'Classe':
        this.processoClasseSelecionada = item.getItem();
        this.apresentarClasse = true;
        break;
      case 'Distribuição':
        this.processoDistribuicaoSelecionada = item.getItem();
        this.apresentarDistribuicao = true;
        break;
      case 'Documento':
        this.processoDocumentoSelecionada = item.getItem();
        this.apresentarDocumento = true;
        break;
      case 'Movimento':
        this.processoMovimentoSelecionada = item.getItem();
        this.apresentarMovimento = true;
        break;
    }
  }

  public onChangeTabViewDocumentos() {
    switch (this.tabViewDocumentosIndex) {
      case ProcessoVisualizadorComponent.TAB_DOCUMENTOS_ORIGINAL:
        this.carregarDocumentoOriginal(this.processoDocumentoSelecionada);
        break;
      case ProcessoVisualizadorComponent.TAB_DOCUMENTOS_TEXTO:
        this.carregarDocumentoTexto(this.processoDocumentoSelecionada);
        break;
    }
  }

  public selecionarProcessoDocumento(processoDocumentoSelecionada: ProcessoDocumento): void {
    this.processoDocumentoSelecionada = processoDocumentoSelecionada;
    this.processoDocumentoTexto = '';
    this.processoDocumentoArquivo = undefined;
    this.onChangeTabViewDocumentos();
  }

  public carregarDocumentoTexto(processoDocumentoSelecionada: ProcessoDocumento) {
    if (processoDocumentoSelecionada.arquivo) {
      this.progressoService.modeless();
      this.processoDocumentoService
        .recuperarTextoPorId(processoDocumentoSelecionada.processo.id, processoDocumentoSelecionada.id)
        .then((texto) => {
          this.progressoService.fechar();
          this.processoDocumentoTexto = texto;
        })
        .catch((resposta) => this.catch('Erro ao recuperar a url de acesso ao recurso', resposta.error));
    }
  }
  public carregarDocumentoOriginal(processoDocumentoSelecionada: ProcessoDocumento) {
    this.progressoService.modeless();
    this.processoDocumentoService
      .recuperarConteudoPorId(processoDocumentoSelecionada.processo.id, processoDocumentoSelecionada.id)
      .then((conteudoOriginal) => {
        this.processoDocumentoArquivo = new ArquivoVisualizavel(
          processoDocumentoSelecionada.nome,
          processoDocumentoSelecionada.tipoArquivo,
          processoDocumentoSelecionada.categoriaArquivo,
          conteudoOriginal
        );
        this.progressoService.fechar();
      })
      .catch((resposta) => this.catch('Erro ao recuperar documento original', resposta.error));
  }

  public processarArquivoEstrutura(): void {
    if (this.processoDocumentoSelecionada !== undefined) {
      this.progressoService.modal();
      this.processoDocumentoService
        .processarArquivoEstruturaPorId(this.processo.id, this.processoDocumentoSelecionada.id)
        .then((_) => {
          this.processoDocumentoService
            .recuperarPorProcessoId(this.processo.id)
            .then((documentos) => {
              this.processoDocumentoSelecionada.processado = true;
              this.processo.documentos = documentos;
              this.processarHierarquia(this.processo.documentos);
              this.selecionarProcessoDocumento(
                documentos.filter((documento) => documento.id === this.processoDocumentoSelecionada.id)[0]
              );
              this.progressoService.fechar();
              this.mensagemService.addSucesso('Sucesso', 'O arquivo foi processado com sucesso!');
            })
            .catch((response) => this.catch('Erro ao carregar os documentos', response.error));
        })
        .catch((response) => this.catch('Erro ao realizar o reprocessamento do arquivo estrutura', response.error));
    }
  }

  public carregarMais(): void {
    Promise.all([this.progressoService.modeless(), this.carregarDocumentos(), this.carregarMovimentos()])
      .then(() => {
        this.listaLinhaTempos = [];
        this.processarLinhaDoTempo();
        this.progressoService.fechar();
      })
      .catch((error) => {
        console.error('Erro ao carregar mais dados', error);
      });
  }
}
